import { GetterTree } from "vuex";

import {
  ActiveProvidersAndAirlinesRefundApiResponse,
  FetchFlightRefundPNRResponse,
  IFlightRefundState,
} from "@/core/interfaces/IFlightRefunds.interface";
import { StoreState } from "@/store/type";

const getters: GetterTree<IFlightRefundState, StoreState> = {
  isPNRFetching: (state): boolean => state.isPNRFetching,
  refundPNRDetails: (state): FetchFlightRefundPNRResponse | null =>
    state.refundPNRDetails,
  refundPNR: (state): string | null => state.refundPNR,
  calculateRefundDetails: (state) => state.calculateDetails,
  refundedDetails: (state) => state.refundedDetails,
  isCalculatingRefund: (state): boolean => state.canCalculateRefund,
  isCommitingRefund: (state): boolean => state.isCommitingRefund,
  isRefundAirlineAndProviderFetching: (state): boolean =>
    state.isRefundAirlineAndProviderFetching,
  refundAirlinesAndProvider: (
    state,
  ): ActiveProvidersAndAirlinesRefundApiResponse | null =>
    state.refundAirlinesAndProvider,
};

export default getters;
